function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30B0\\u30EB\\u30FC\\u30D7_24436",
  "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24436",
  transform: "translate(-14 42) rotate(-90)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u9577\\u65B9\\u5F62_13620",
  "data-name": "\\u9577\\u65B9\\u5F62 13620",
  width: 24,
  height: 24,
  transform: "translate(18 14)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "arrow_forward_ios_FILL0_wght400_GRAD0_opsz24",
  d: "M251.6-862l-1.6-1.6,7.4-7.4-7.4-7.4,1.6-1.6,9,9Z",
  transform: "translate(285 -845) rotate(180)",
  fill: "#a59785"
}));

var SvgIconPulldown = function SvgIconPulldown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPulldown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_pulldown.bb84e75f.svg";
export { ForwardRef as ReactComponent };